module.exports = __webpack_public_path__ + "static/img/s4.9754a45.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/s4.png
// module id = LEOw
// module chunks = 0